var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- components/cnt-list/component--><div class=\"tabs\"><div v-if=\"tables.expense.length &gt; 0\" class=\"operation\"><a v-link=\"{name: 'close-store' }\" class=\"button\">Закрытие склада</a></div><ul class=\"nomarkers\"><li>Приход</li><li>Расход</li><li>В пути</li><li>Разнарядка</li></ul><div><div><component is=\"cnt-list-table\" v-if=\"tables\" data-title=\"Приход\" data-table=\"{{ tables.expense }}\" data-date-out-show=\"false\" data-column-sort=\"date_in\" data-reverse=\"false\"></component></div><div><component is=\"cnt-list-table\" v-if=\"tables\" data-title=\"Расход\" data-table=\"{{ tables.balance }}\" data-date-out-show=\"true\" data-column-sort=\"date_in\" data-reverse=\"false\"></component></div><div><component is=\"train-in-way\"></component></div><div><component is=\"cnt-poezd\"></component></div></div></div><component is=\"alert\" name=\"cnt-list\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/cnt-list/component.jade
 ** module id = 73
 ** module chunks = 0
 **/